import $ from 'jquery'
import 'slick-carousel'


export const renderHotelIntroSliderDots = (
  sliderDots,
) => {
  [...sliderDots].forEach((item) => {
    const holder = $(item)
    const hotelIntroSliderDots = holder.find('.with-dots')

    hotelIntroSliderDots.each(() => {
      const btnPrev = holder.find('.btn-prev')
      const btnNext = holder.find('.btn-next')

      if (!hotelIntroSliderDots.find('.item').length) {
        hotelIntroSliderDots.addClass('no-items')
      }

      hotelIntroSliderDots.slick({
        rows: 0,
        dots: true,
        arrows: true,
        prevArrow: btnPrev,
        nextArrow: btnNext,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 15,
        accessibility: false,
      })

      if (hotelIntroSliderDots.find('.item').length < 2) {
        hotelIntroSliderDots.find('.slick-dots').hide()
      }

      btnPrev.on('keypress', function (e) {
        if (
            e.type === "keydown" &&
            e.key !== "Enter" &&
            e.key !== " "
        ) {
          return
        }
        hotelIntroSliderDots.slick('slickPrev')
      })

      btnPrev.on('keypress', function (e) {
        if (
            e.type === "keydown" &&
            e.key !== "Enter" &&
            e.key !== " "
        ) {
          return
        }
        hotelIntroSliderDots.slick('slickNext')
      })

    })
  })
}
